import Cookies from 'js-cookie';
import { ICookie, ICookiesService } from '../cookies';

class CookiesService extends ICookiesService {
    public getCookie(name: string): string {
        const cookie = Cookies.get(name);
        return cookie;
    }

    public setCookie(cookie: ICookie) {
        if (cookie.expirationDate) {
            Cookies.set(cookie.name, cookie.value, { expires: cookie.expirationDate, secure: true });
        } else {
            Cookies.set(cookie.name, cookie.value);
        }
    }

    public deleteCookie(name: string) {
        Cookies.remove(name);
    }
}

export { CookiesService };